import { render, staticRenderFns } from "./user-dropdown.vue?vue&type=template&id=2ae09bc2"
import script from "./user-dropdown.vue?vue&type=script&lang=js"
export * from "./user-dropdown.vue?vue&type=script&lang=js"
import style0 from "./user-dropdown.vue?vue&type=style&index=0&id=2ae09bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports